import { createApiOperation } from "../api-client/create-api-operation";

export const Sections = {
  getFields: createApiOperation<string[], "/Api/Sections/Fields", "get">(
    "/Api/Sections/Fields",
    "get",
  ),
};
